module.exports = __webpack_public_path__ + "img/HPS011SH.7e72cc3c.png";